import { COLORS } from '@cuemath/comps';

//* This ID belongs to akash_student;
export const stCreatedByDummyId = '1bfd0c1e-ec95-11e8-9b4a-02420a0000e2';

export const TRANSFER_REASONS = {
  TEACHER_ASKED_TO_EXIT_SYSTEM: 'Teacher asked to exit the system',
  TEACHER_ON_LONG_PAUSE: 'Teacher on long pause',
  TEACHER_HAS_RESIGNED: 'Teacher has resigned',
  PARENT_UNHAPPY: 'Parent is unhappy',
  TEACHER_UNHAPPY: 'Teacher is not happy with parent',
  CLASS_SLOT_ISSUE: 'Class slot issues',
  TEACHER_NOT_LICENSED: 'Teacher not licensed',
  PREFERRED_TEACHER: 'Preferred teacher',
  STUDENT_IS_IN_1_6_BATCH: 'Student is in a 1:6 batch',
  MEDICAL_EMERGENCY: 'Medical emergency',
  ADMIN_DIRECT_TRANSFER: 'Admin direct transfer',
};

export const BULK_TRANSFER_REASONS_OPTIONS = [
  {
    id: 'TEACHER_ASKED_TO_EXIT_SYSTEM',
    label: 'Teacher asked to exit the system',
    value: 'Teacher asked to exit the system',
  },
  {
    id: 'TEACHER_ON_LONG_PAUSE',
    label: 'Teacher on long pause',
    value: 'Teacher on long pause',
  },
  {
    id: 'TEACHER_HAS_RESIGNED',
    label: 'Teacher has resigned',
    value: 'Teacher has resigned',
  },
];

export const STUDENT_TRANSFER_REASONS_OPTIONS = [
  { id: 'PARENT_UNHAPPY', label: 'Parent is unhappy', value: 'Parent is unhappy' },
  {
    id: 'TEACHER_UNHAPPY',
    label: 'Teacher is not happy with parent',
    value: 'Teacher is not happy with parent',
  },
  { id: 'CLASS_SLOT_ISSUE', label: 'Class slot issues', value: 'Class slot issues' },
  {
    id: 'TEACHER_NOT_LICENSED',
    label: 'Teacher not licensed',
    value: 'Teacher not licensed',
  },
  { id: 'PREFERRED_TEACHER', label: 'Preferred teacher', value: 'Preferred teacher' },
  {
    id: 'STUDENT_IS_IN_1_6_BATCH',
    label: 'Student is in a 1:6 batch',
    value: 'Student is in a 1:6 batch',
  },
  {
    id: 'MEDICAL_EMERGENCY',
    label: 'Medical emergency',
    value: 'Medical emergency',
  },
  ...BULK_TRANSFER_REASONS_OPTIONS,
];

export const DAYS_NAME = [
  {
    id: 'monday',
    label: 'Monday',
    value: 'Monday',
  },
  {
    id: 'tuesday',
    label: 'Tuesday',
    value: 'Tuesday',
  },
  {
    id: 'wednesday',
    label: 'Wednesday',
    value: 'Wednesday',
  },
  {
    id: 'thursday',
    label: 'Thursday',
    value: 'Thursday',
  },
  {
    id: 'friday',
    label: 'Friday',
    value: 'Friday',
  },
  {
    id: 'saturday',
    label: 'Saturday',
    value: 'Saturday',
  },
  {
    id: 'sunday',
    label: 'Sunday',
    value: 'Sunday',
  },
];

export const EXCEPTION_REASONS = [
  TRANSFER_REASONS.TEACHER_NOT_LICENSED,
  TRANSFER_REASONS.MEDICAL_EMERGENCY,
  BULK_TRANSFER_REASONS_OPTIONS[1].label,
];

export const TRANSFER_STATUS_FILTER_OPTIONS = [
  {
    key: 'SUCCESSFUL',
    label: 'Class booked',
    value: 'SUCCESSFUL',
  },
  {
    key: 'TEACHER_ASSIGNED',
    label: 'Transfer successful',
    value: 'TEACHER_ASSIGNED',
  },
  {
    key: 'INITIATED',
    label: 'Slots pending',
    value: 'INITIATED',
  },
  {
    key: 'TEACHER_NOT_FOUND',
    label: 'Teacher not found',
    value: 'TEACHER_NOT_FOUND',
  },
  {
    key: 'PARENT_UNHAPPY',
    label: 'Parent unhappy',
    value: 'PARENT_UNHAPPY',
  },
  {
    key: 'TEACHER_REQUESTED',
    label: 'Searching teacher',
    value: 'TEACHER_REQUESTED',
  },
  {
    key: 'NO_CANDIDATE_TEACHER_ACCEPTED',
    label: 'No candidate teacher accepted',
    value: 'NO_CANDIDATE_TEACHER_ACCEPTED',
  },
];

export const REGION_FILTER_OPTION = [
  {
    key: 'INDIA',
    label: 'India',
    value: 'India',
  },
  {
    key: 'USA',
    label: 'USA',
    value: 'USA',
  },
];

export const REGULAR_SLOTS_FILTER_OPTION = [
  {
    key: 'PENDING',
    label: 'Pending',
    value: 'Pending',
  },
  {
    key: 'REGULAR',
    label: 'Regular',
    value: 'Regular',
  },
];

export const CLASS_COMPLETED_FILTER_OPTION = [
  {
    key: 'ZERO',
    label: 'Zero',
    value: 0,
  },
  {
    key: 'ONE',
    label: 'One',
    value: 1,
  },
  {
    key: 'TWO',
    label: 'Two',
    value: 2,
  },
  {
    key: 'THREE',
    label: 'Three',
    value: 3,
  },
];

export const STATUS_CARDS = {
  SUCCESSFUL: {
    text: '👍🏼 Class booked',
    bgColor: COLORS.GRASS_XXLIGHT,
  },
  TEACHER_ASSIGNED: {
    text: '✅ Transfer successful',
    bgColor: COLORS.GRASS_XXLIGHT,
  },
  INITIATED: {
    text: '⏳ Slots pending',
  },
  TEACHER_NOT_FOUND: {
    text: '🛑 Teacher not found',
  },
  PARENT_UNHAPPY: {
    text: '🙁 Parent unhappy',
  },
  TEACHER_REQUESTED: {
    text: '🔍 Searching teacher',
  },
  SLOT_PENDING: {
    text: '⏳ Slots pending',
  },
  TRIAL_SLOT_PENDING: {
    text: '⏳ Trial Slots pending',
  },
  DIRECT_MAPPING_REQUESTED: {
    text: '⏳ Assigning Teacher For Trial Via Direct Mapping',
  },
  NO_CANDIDATE_TEACHER_ACCEPTED: {
    text: '🙁 No candidate teacher accepted',
  },
};

export const SDT_DRAWER_CARD = {
  TEACHER_NOT_FOUND: {
    view: 'st-teacher-not-found',
    title: 'Teacher not found',
    props: {
      teacher_found: false,
    },
  },
  INITIATED: {
    view: 'student-transfer-slot-pending',
    title: 'Slot Pending',
  },
  NOT_STARTED: {
    view: 'student-transfer-slot-pending',
    title: 'Slot Pending',
  },
  TEACHER_REQUESTED: {
    view: 'st-searching-teacher',
    title: 'Searching teacher',
    props: {
      studentName: 'Bingo',
    },
  },
  SUCCESSFUL: {
    view: 'st-class-booked',
    title: 'Class booked',
  },
  PARENT_UNHAPPY: {
    view: 'st-parent-unhappy',
    title: 'Parent unhappy',
  },
  TEACHER_ASSIGNED: {
    view: 'st-transfer-successful',
    title: 'Transfer successful',
  },
  SLOT_PENDING: {
    view: 'student-transfer-slot-pending',
    title: 'Slot Pending',
  },
  NO_CANDIDATE_TEACHER_ACCEPTED: {
    view: 'st-teacher-not-found',
    title: 'Teacher not found',
    props: {
      teacher_found: false,
    },
  },
  EDIT_STUDENT_SLOT: {
    view: 'st-edit-slots',
    title: 'Edit slot',
  },
};
